export const InsertSectionShadow = {
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
  height: 'E3',
  // ZERO-SIZE-SHIPPED-1 #2: an EMPTY box with `height` still compresses to
  // 0px the moment an instance participates in flex flow (the InviteDropdown
  // override flips `position` to sticky inside a height-capped overflow:auto
  // flex column — default flex-shrink:1 + min-content 0 ate the whole box;
  // qa measured "correct gradient, computed height 0"). Inert for this base's
  // own absolute positioning (flex properties are ignored for abs children),
  // load-bearing for every in-flow reuse.
  flex: '0 0 auto',
  background: 'linear-gradient(0deg, var(--theme-common-box-dark-background) 5%, transparent 100%)',
  pointerEvents: 'none'
}
